import { SectionView } from '@views';
import { DrawerSectionSource, NextSurveySectionResponse } from '@viewCreators/next-survey-section-view-creator';

/**
 * The drawer records answers by writing onto the ResponseView objects it renders, so the
 * section it works from has to be ours alone — sharing the query cache's copy means any
 * refetch swaps in fresh, blank objects and quietly discards everything answered so far.
 */
const cloneSection = (section: SectionView): SectionView => JSON.parse(JSON.stringify(section)) as SectionView;

export type WorkingSection = {
  source: DrawerSectionSource;
  section: SectionView;
};

/**
 * Take a private copy of whatever section the server is serving, but only when it is a
 * section we are not already working on. Re-adopting the section in progress — which any
 * refetch would do — is what blanked out answers and submitted empty responses. A section
 * is identified by its source as well as its id, since a survey section and a questionnaire
 * sitting can share an id.
 */
export const nextWorkingSection = (
  current: WorkingSection | null,
  incoming: NextSurveySectionResponse
): WorkingSection | null => {
  if (!incoming.section || incoming.section.questions.length === 0) return null;
  if (current && current.source === incoming.source && current.section.id === incoming.section.id) {
    return current; // already working on this section — keep it, answers and all
  }
  return { source: incoming.source, section: cloneSection(incoming.section) };
};
